import debounce from 'debounce'

async function init() {
	var freightSansCmpProSemiItalic = new FontFace(
		'freightSansCmpPro',
		'url(/wp-content/themes/propaganda-theme/assets/fonts/FreightSansCmpPro-Semi-Italic.woff2)',
		{
			weight: '600',
		}
	)
	var freightSansCmpProBlack = new FontFace(
		'freightSansCmpPro',
		'url(/wp-content/themes/propaganda-theme/assets/fonts/FreightSansCmpPro-Black.woff2)',
		{
			style: 'normal',
			weight: '900',
		}
	)

	var [semiItal, black] = await Promise.all([
		freightSansCmpProSemiItalic.load(),
		freightSansCmpProBlack.load(),
	])
	document.fonts.add(semiItal)
	document.fonts.add(black)

	const dpi = window.devicePixelRatio

	var canvas = document.getElementById('canvas')
	canvas.width = window.innerWidth * dpi
	canvas.height = window.innerHeight * dpi
	var ctx = canvas.getContext('2d')
	ctx.scale(dpi, dpi)

	var minBaseFontSize = 60
	var minShadowDepth = 24
	var baseFontSize = (window.innerWidth / 19.2) * dpi
	var shadowDepth = (window.innerWidth / 48) * dpi
	baseFontSize = baseFontSize < minBaseFontSize ? minBaseFontSize : baseFontSize
	shadowDepth = shadowDepth < minShadowDepth ? minShadowDepth : shadowDepth
	var textStroke = window.innerWidth > 992 ? 2 * dpi : 1 * dpi

	var static_canvas_wrapper = document.getElementById('static-canvas')
	var static_canvas_img
	var past_img_url

	class Word {
		constructor(
			text,
			weight,
			style,
			size,
			family,
			letterSpacing,
			primaryColor,
			secondaryColor,
			hasLines
		) {
			this.text = text
			this.weight = weight
			this.style = style
			this.family = family
			this.size = size
			this.font = `${weight} ${style} ${size}px ${family}`
			this.primaryColor = primaryColor
			this.secondaryColor = secondaryColor
			this.letterSpacing = letterSpacing + 'em'

			this.setSize()

			this.hasLines = hasLines
		}

		setPos(x, y) {
			this.posX = x
			this.posY = y
		}

		setFontSize(size) {
			this.size = size
			this.font = `${this.weight} ${this.style} ${this.size}px ${this.family}`
			this.setSize()
		}

		setSize() {
			ctx.font = this.font
			ctx.letterSpacing = this.letterSpacing
			var textMeasure = ctx.measureText(this.text)
			this.width = textMeasure.width
			this.height =
				textMeasure.actualBoundingBoxAscent +
				textMeasure.actualBoundingBoxDescent
		}

		drawText() {
			this.fillText()
			this.strokeText()
			this.drawTextShadow()
		}

		fillText() {
			ctx.fillStyle = this.primaryColor
			ctx.font = this.font
			ctx.letterSpacing = this.letterSpacing
			ctx.fillText(this.text, this.posX, this.posY)
		}

		strokeText() {
			ctx.lineWidth = textStroke
			ctx.strokeStyle = this.secondaryColor
			ctx.strokeText(this.text, this.posX, this.posY)
		}

		drawTextShadow() {
			ctx.globalCompositeOperation = 'destination-over'
			ctx.fillStyle = this.secondaryColor
			ctx.lineWidth = textStroke
			ctx.strokeStyle = this.secondaryColor
			var n
			for (n = 0; n < shadowDepth; n++) {
				ctx.fillText(this.text, this.posX - n, this.posY + n / 3)
				ctx.strokeText(this.text, this.posX - n, this.posY + n / 3)
			}
			ctx.globalCompositeOperation = 'source-over'
		}

		addLines() {
			let lines = []
			for (let n = 0; n < 5; n++) {
				lines.push({
					y: this.posY + (this.height / 5) * (5 - n) - this.height,
				})
			}
			this.lines = lines
		}

		drawLines() {
			this.lines.forEach(line => {
				let speed =
					(this.posY + this.height - line.y) / this.height +
					0.5 * (window.innerWidth / 1000)
				line.y = line.y - speed

				if (line.y < this.posY - this.height) {
					line.y = this.posY
				}

				let lineWidth = (this.posY - line.y) / 20

				ctx.beginPath()
				ctx.moveTo(0, line.y)
				ctx.lineTo(canvas.width, line.y)
				ctx.lineWidth = lineWidth > 4 ? lineWidth : 4
				ctx.strokeStyle = '#f6b0b9'
				ctx.stroke()
			})
		}
	}

	var word1, word2, word3, word4

	word1 = new Word(
		'STAY',
		900,
		'normal',
		baseFontSize * 3.1,
		'freightSansCmpPro',
		-0.01,
		'#20b792',
		'#572b2c',
		false
	)
	word2 = new Word(
		'IN',
		600,
		'italic',
		baseFontSize * 1.95,
		'freightSansCmpPro',
		-0.01,
		'#20b792',
		'#572b2c',
		false
	)
	word3 = new Word(
		'THE',
		600,
		'italic',
		baseFontSize * 1.03,
		'freightSansCmpPro',
		-0.01,
		'#20b792',
		'#572b2c',
		false
	)
	word4 = new Word(
		'LOOP',
		900,
		'normal',
		baseFontSize * 3.85,
		'freightSansCmpPro',
		-0.02,
		'#20b792',
		'#572b2c',
		true
	)

	function setup() {
		ctx.reset()

		baseFontSize = (window.innerWidth / 19.2) * dpi
		shadowDepth = (window.innerWidth / 48) * dpi
		baseFontSize =
			baseFontSize < minBaseFontSize ? minBaseFontSize : baseFontSize
		shadowDepth = shadowDepth < minShadowDepth ? minShadowDepth : shadowDepth
		textStroke = window.innerWidth > 992 ? 2 * dpi : 1 * dpi

		word1.setFontSize(baseFontSize * 3.1)
		word2.setFontSize(baseFontSize * 1.95)
		word3.setFontSize(baseFontSize * 1.03)
		word4.setFontSize(baseFontSize * 3.85)

		canvas.width = shadowDepth + word4.width
		canvas.height = word1.height + word4.height * 1.03 + shadowDepth
		canvas.setAttribute(
			'style',
			`--width: ${canvas.width / dpi}px; --height: ${canvas.height / dpi}px;`
		)

		word1.setPos(shadowDepth, word1.height)
		word2.setPos(shadowDepth * 0.8 + word1.width, word2.height * 1.065)
		word3.setPos(
			shadowDepth * 0.8 + word1.width - word2.width * 0.08,
			word2.height + word3.height * 1.24
		)
		word4.setPos(
			shadowDepth + word4.width * -0.01,
			word1.height + word4.height * 1.03
		)

		word4.addLines()
		word4.drawText()

		word1.drawText()

		word2.drawText()

		word3.drawText()

		ctx.globalCompositeOperation = 'destination-out'
		word4.fillText()

		canvas.toBlob(blob => {
			if (past_img_url) {
				URL.revokeObjectURL(past_img_url)
			}

			const newImg = document.createElement('img')
			const url = URL.createObjectURL(blob)
			past_img_url = url

			newImg.onload = () => {
				URL.revokeObjectURL(url)
			}

			newImg.src = url
			newImg.alt = 'Stay In The Loop'

			if (!static_canvas_img) {
				static_canvas_wrapper.appendChild(newImg)
				static_canvas_img = newImg
			} else {
				static_canvas_img.setAttribute('src', url)
			}
		})
	}

	function animationLoop() {
		ctx.clearRect(0, 0, canvas.width, canvas.height)

		ctx.globalCompositeOperation = 'source-over'
		word4.fillText()
		word4.drawLines()
		ctx.globalCompositeOperation = 'destination-atop'
		word4.fillText()
		ctx.globalCompositeOperation = 'source-over'
		word4.strokeText()

		window.requestAnimationFrame(animationLoop)
	}

	setup()
	window.requestAnimationFrame(animationLoop)

	window.onresize = debounce(setup, 50)
}

init()
